import React from 'react';
import './App.css';
import WelcomeSection from './components/WelcomeSection';
import MessageList from './components/MessageList';
import InputArea from './components/InputArea';
import Footer from './components/Footer';
import Notification from './components/Notification';
import { BOOKING } from './config';
import { useChat } from './hooks/useChat';

function App() {
  const {
    messages,
    input,
    loading,
    errorMessage,
    showNotification,
    messagesEndRef,
    setInput,
    setErrorMessage,
    setShowNotification,
    sendMessage,
    startNewConversation,
    handleKeyPress
  } = useChat();

  return (
    <div className="App">
      <span className="wordmark">Shravanth</span>

      <a
        className="book-call-top"
        href={BOOKING.CAL_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Book a call with Shravanth"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <span className="book-call-top-label">Book a Call</span>
      </a>

      <div className="chat-container">
        {messages.length === 0 && (
          <WelcomeSection onSuggestionClick={sendMessage} />
        )}

        {messages.length > 0 && (
          <MessageList
            messages={messages}
            loading={loading}
            messagesEndRef={messagesEndRef}
          />
        )}

        <InputArea
          input={input}
          loading={loading}
          showNewConversation={messages.length > 0}
          onInputChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          onSend={() => sendMessage()}
          onNewConversation={startNewConversation}
        />

        <Footer />
      </div>

      <Notification
        show={showNotification}
        message="The backend runs on a free tier and may take up to 50 seconds to wake up on the first message. Thanks for your patience!"
        duration={5000}
        onClose={() => setShowNotification(false)}
      />

      <Notification
        show={!!errorMessage}
        title="Connection Issue"
        message={errorMessage}
        duration={6000}
        onClose={() => setErrorMessage('')}
      />
    </div>
  );
}

export default App;
